import { render } from "./FooterTallosInformations.vue?vue&type=template&id=e5a5f65a&scoped=true"
import script from "./FooterTallosInformations.vue?vue&type=script&lang=js"
export * from "./FooterTallosInformations.vue?vue&type=script&lang=js"

import "./FooterTallosInformations.vue?vue&type=style&index=0&id=e5a5f65a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5a5f65a"]])

export default __exports__